var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"carousel-button",on:{"click":function($event){return _vm.$emit('click', _vm.verifiedType)}}},[_c('img',{attrs:{"src":_vm.arrowIcon,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }